import PropTypes from 'prop-types';

export const defaultProps = {
  points: PropTypes.string,
};

export const propTypes = {
  points: '',
};
